export const cardDetails = {
    CREDIT: {
        AUTHORIZED_STANDALONE: { fields: [['balance'], ['owner', 'validDates']] },
        MAIN: {
            fields: [
                [
                    'balance',
                    'limit',
                    'outstandingAmount',
                    'installmentDueDate',
                    'currentCycleTurnover',
                    'overDueAmount',
                ],
                [
                    'currentCycleEndDate',
                    'previousCycleEndDate',
                    'outstandingMonthlyAmount',
                    'minimalMonthlyAmount',
                ],
                ['owner', 'validDates'],
            ],
        },
    },
};
